import { LegalLayout } from './LegalLayout';

const SUPPORT_EMAIL = 'support@radiologylive.ai';
const LAST_UPDATED = '2026-02-26';

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service">
      <p className="text-sm text-muted-foreground">
        Last updated: {LAST_UPDATED}
      </p>

      <p>
        These Terms of Service (&quot;Terms&quot;) govern your access to and use of the RadiologyLive.ai
        websites, applications, and related services (collectively, the &quot;Services&quot;) provided by
        Radiologylive.ai, LLC (&quot;RadiologyLive.ai&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;). By creating an account,
        downloading software, or using the Services, you agree to these Terms.
      </p>

      <h2>1. Who may use the Services</h2>
      <p>
        You may use the Services only if you can form a binding contract and will use the Services in
        your professional capacity. If you use the Services on behalf of an organization, you
        represent that you have authority to bind that organization to these Terms.
      </p>

      <h2>2. Clinical responsibility; no medical advice</h2>
      <p>
        The Services are tools intended to support radiology workflows. The Services do not provide
        medical advice and are not a substitute for professional judgment. You remain solely
        responsible for verifying accuracy and completeness, complying with applicable law and
        policies, and for the final radiology report and clinical decisions.
      </p>

      <h2>3. HIPAA and patient data: restrictions and shared responsibility</h2>
      <p>
        <strong>3.1 No patient identifiers by default.</strong> Unless and until RadiologyLive.ai explicitly
        enables a HIPAA/BAA-backed workflow and you complete any required consent/attestation steps,
        you agree not to input, upload, transmit, or otherwise provide patient identifiers or other
        Protected Health Information (&quot;PHI&quot;) to the Services. Patient identifiers include, by way of
        example: patient name, MRN, date of birth, accession number, address, phone number, email, or
        any other data that could reasonably identify a patient.
      </p>
      <p>
        <strong>3.2 Shared responsibility.</strong> HIPAA compliance is shared. You and your organization
        are responsible for appropriate policies, access governance, and workflows. RadiologyLive.ai may
        provide technical controls that support secure use, but those controls do not replace your
        obligations.
      </p>
      <p>
        <strong>3.3 Future HIPAA mode.</strong> If and when RadiologyLive.ai offers a HIPAA/BAA-backed
        workflow, additional terms may apply and you may be required to execute a BAA and/or enable
        specific configurations before PHI is permitted.
      </p>

      <h2>4. Accounts and security</h2>
      <p>
        You are responsible for maintaining the confidentiality of your credentials and for all
        activity under your account. You must promptly notify us of any suspected unauthorized
        access.
      </p>

      <h2>5. Acceptable use</h2>
      <ul>
        <li>No unlawful, abusive, or harmful use.</li>
        <li>No attempts to bypass security controls or access other users’ data.</li>
        <li>No interference with the Services, including probing or load testing without permission.</li>
        <li>No reverse engineering except where prohibited by law.</li>
      </ul>

      <h2>6. Fees and changes</h2>
      <p>
        Some features may require payment. Pricing, plan limits, and availability may change.
      </p>

      <h2>7. Disclaimers</h2>
      <p>
        THE SERVICES ARE PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot;. TO THE MAXIMUM EXTENT PERMITTED BY
        LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR
        A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, Radiologylive.ai, LLC WILL NOT BE LIABLE FOR INDIRECT,
        INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR FOR LOST PROFITS/REVENUE, LOST
        DATA, OR BUSINESS INTERRUPTION.
      </p>

      <h2>9. Termination</h2>
      <p>
        We may suspend or terminate access if you violate these Terms or if we reasonably believe
        your use creates security, legal, or operational risk.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions about these Terms: <a className="text-primary hover:underline" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
      </p>

      <p className="text-xs text-muted-foreground">
        Note: This is a high-quality draft intended for beta. Have counsel review before broad
        commercial launch.
      </p>
    </LegalLayout>
  );
}
